module.exports = __webpack_public_path__ + "img/5.a39fb7d7.png";